import { Chart } from 'chart.js';

export const standardTitleStyle = {
  font: { size: 16, weight: 600 },
  padding: { top: 8, bottom: 16 }
};

export const standardTitle = (text: string) => ({
  display: true,
  text,
  ...standardTitleStyle
});

export const standardLegend = {
  position: 'bottom' as const,
  labels: {
    usePointStyle: true,
    padding: 12,
    boxWidth: 12
  }
};

export const standardAxisTitleFont = { size: 14, weight: 'bold' as const };
export const standardAxisTickFont = { size: 12 };

export const registerStandardChartFormatting = () => {
  Chart.register({
    id: 'standardChartFormatting',
    beforeInit(chart) {
      const plugins = chart.options.plugins || {};
      const legend = plugins.legend;
      const title = plugins.title;

      if (legend && legend.display !== false) {
        legend.position = standardLegend.position;
        legend.labels = {
          ...standardLegend.labels,
          ...(legend.labels || {})
        };
      }

      if (title && title.display !== false) {
        const titleFont = typeof title.font === 'object' && title.font ? title.font : {};
        const titlePadding = typeof title.padding === 'object' && title.padding ? title.padding : {};
        title.font = {
          ...standardTitleStyle.font,
          ...titleFont
        };
        title.padding = {
          ...standardTitleStyle.padding,
          ...titlePadding
        };
      }

      const scales: any = (chart.options as any).scales;
      if (scales && typeof scales === 'object') {
        Object.values(scales).forEach((scale: any) => {
          if (!scale || typeof scale !== 'object') return;
          if (scale.title && scale.title.display !== false) {
            scale.title.font = {
              ...(scale.title.font || {}),
              ...standardAxisTitleFont
            };
          }
          if (scale.ticks) {
            scale.ticks.font = {
              ...(scale.ticks.font || {}),
              ...standardAxisTickFont
            };
          }
        });
      }
    }
  });
};

